import axios from "axios";
import * as actions from "./actionTypes";
import messages from "../../messages";
import toastr from "toastr";
import CompetencyQuestionServices from "./competencyQuestions.services";

export const getCompetencyQuestions =  ( filters, setData, setCount,  setLoader, setError,  setFormError) => async (dispatch) => {
  try {
   setLoader(true);
    const resp = await CompetencyQuestionServices.getCompetencyQuestions(filters);
    setData(resp.data.data);
    setCount(resp.data.count );
    setError('');
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
   setError(message);
  } finally {
   setLoader(false);
  }
}

export const deleteCompetencyQuestion = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_COMPETENCY_QUESTIONS,
      payload: true,
    });
    await CompetencyQuestionServices.deleteCompetencyQuestion(id);
    const { data, count } = getState().competencyQuestion.competencyQuestion;
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_COMPETENCY_QUESTIONS,
      payload: {
        data: _data,
        count: count - 1
      },
    });
    dispatch({
      type: actions.COMPETENCY_QUESTIONS_FALLA,
      payload: '',
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.COMPETENCY_QUESTIONS_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_COMPETENCY_QUESTIONS,
      payload: false,
    });
  }
}

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const editCompetencyQuestion = (req, competencia_id, index, data,  setData, count, setCount, setSaveLoader, setError, setFormError) => async (dispatch, getState) => {


  try {

    setSaveLoader(true);
    const resp = await CompetencyQuestionServices.editCompetencyQuestion(competencia_id, req);
    console.log(resp)

    const dataT = data
    dataT[index] = resp.data
    setData(dataT);
    setFormError('');
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
  setFormError(message);
  } finally {
  setSaveLoader(false);
  }
}

export const saveCompetencyQuestion = (req, data, setData, count, setCount, setSaveLoader, setError, setFormError) => async (dispatch, getState) => {
  try {
    setSaveLoader(true);
    const resp = await CompetencyQuestionServices.saveCompetencyQuestion(req);
    const _data = data;
    _data.push(resp.data)
    setData(_data);
    setCount(count + 1);
    setFormError('');
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
    
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    setFormError(message);
  } finally {
    setSaveLoader(false);
    
  }
};
